import {Grid} from '@logistics-frontend/blocks'

import {appClasses} from './FooterApp@desktop.classes'

export type FooterAppProps = {
  qr: JSX.Element
  stores: JSX.Element
}

export function FooterApp({qr, stores}: FooterAppProps): React.ReactElement {
  return (
    <Grid className={appClasses.root} wrap="nowrap" container>
      <Grid item>{qr}</Grid>
      <Grid className={appClasses.stores} direction="column" wrap="nowrap" container item>
        {stores}
      </Grid>
    </Grid>
  )
}
